import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-conteudo',
  templateUrl: './conteudo.component.html',
  styleUrls: ['./conteudo.component.css']
})
export class ConteudoComponent implements OnInit {
  
  temas = {
    escuro: { 
      'border-radius': '5px',
      'background-color': 'rgba(49, 26, 149, 0.5)'
    }
  }

  @Input() lendo: boolean;
  @Input() quantidade: number =  1;
  @Input() aparencia: "" | "circle" | "line" = 'line';
  @Input() animacao: string = 'pulse';
  @Input() largura: string = null;
  @Input() altura: string = null;
  @Input() tema: string = null;
  @Input() texto: string;

  theme: { [k: string]: any; } = null;

  constructor() { }

  ngOnInit(): void {
    this.theme = this.temas[this.tema] ||{};

    this.theme['width'] = this.largura || '750px';
    this.theme['height'] = this.altura || '20px'; 
  }

}
